export default function() {
  return this.axis().find(d => d.target === 'x');
}


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/rectLinear/axisX.js